const SESSION_STORAGE_PREFIX = "assistant-session-id";
const AGENT_SESSION_STORAGE_PREFIX = "assistant-agent-session-id";

export const assistantSessionStorageKey = (role = "patient", userId = "guest") =>
  `${SESSION_STORAGE_PREFIX}:${String(role || "patient").toLowerCase()}:${userId || "guest"}`;

export const agentSessionStorageKey = (role = "patient", userId = "guest") =>
  `${AGENT_SESSION_STORAGE_PREFIX}:${String(role || "patient").toLowerCase()}:${userId || "guest"}`;

export const createAssistantSessionId = () => {
  if (globalThis.crypto?.randomUUID) return `session_${globalThis.crypto.randomUUID()}`;
  const bytes = new Uint8Array(16);
  globalThis.crypto.getRandomValues(bytes);
  return `session_${Array.from(bytes, (value) => value.toString(16).padStart(2, "0")).join("")}`;
};

export const getPersistentAssistantSessionId = (role, userId, storage = globalThis.localStorage) => {
  const key = assistantSessionStorageKey(role, userId);
  try {
    const saved = storage.getItem(key);
    if (saved) return saved;
    const next = createAssistantSessionId();
    storage.setItem(key, next);
    return next;
  } catch {
    return createAssistantSessionId();
  }
};

export const getPersistentAgentSessionId = (role, userId, storage = globalThis.localStorage) => {
  try {
    const key = agentSessionStorageKey(role, userId);
    const saved = storage.getItem(key);
    if (saved) return saved;
    const previous = storage.getItem(assistantSessionStorageKey(role, userId));
    const next = previous || createAssistantSessionId();
    storage.setItem(key, next);
    return next;
  } catch {
    return createAssistantSessionId();
  }
};

export const createNewAgentSession = (role, userId, storage = globalThis.localStorage) => {
  const next = createAssistantSessionId();
  try {
    storage.setItem(agentSessionStorageKey(role, userId), next);
  } catch {
    // Keep the new conversation usable when browser storage is unavailable.
  }
  return next;
};
